import { Grid } from '@mui/material';
import React from 'react';
import NavBar from '../Screen/NavBar/NavBar';
import FAQs from './Info/FAQs';
import imag from '../Asset/InfoImage/Glow.png'
import FooterPage from './FooterPage';
const InfoPage = () => {
  return (
    <Grid container>
        <Grid item md={2} lg={2} xl={2}>
            <NavBar />
        </Grid>
        <Grid item xs={12} sm={12} md={4} lg={4} xl={4} sx={{textAlign:'center',paddingTop:'10%'}}>
            <img src={imag} alt='Image' width={"60%"} />
        </Grid>
        <Grid item xs={12} sm={12} md={5} lg={5} xl={5} sx={{padding:'5px'}}>
            <FAQs />
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <Grid container sx={{background: "linear-gradient(to top, rgb(0, 0, 0) 65%, rgb(20, 22, 38) 100%)"}}>
        <Grid item xs={0} sm={0} md={2} lg={2} xl={2}></Grid>
        <Grid item xs={12} sm={12} md={10} lg={10} xl={10}>
          <FooterPage />
        </Grid>
      </Grid>
      </Grid>
    </Grid>
  );
};

export default InfoPage;